import { legacy_createStore as createStore} from 'redux'

// Define initial state
const initialState = {
    userEmail: null,
};

// Create a reducer
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'updateUserEmail':
            return {...state, userEmail: action.payload};
        case 'cleanUserEmail':
            return {...state, userEmail: null};
        default:
            return state;
    }
};

// Create store
const store = createStore(reducer);

// Export
export default store;
